<script lang="ts">
    import {push} from 'svelte-spa-router'
    export let params = {};

    $: {

        if (params && params.affid) {
            window.localStorage.setItem("aff",params.affid)
            setTimeout(() => {
                push("/register")
            }, 500);
        }
    }
</script>